module.exports = __webpack_public_path__ + "dingbeauty-landing/img/industry_02@1.02e5b071.png";